import { ArrowRight } from "lucide-react";
import { Link } from "react-router";

type HomeStoryOpeningProps = { signedIn: boolean; loadingSession: boolean };

export function HomeStoryOpening({ signedIn, loadingSession }: HomeStoryOpeningProps) {
  return (
    <div className="home-story-opening">
      <h1 id="home-story-title">
        <span>让作品的</span>
        <span>第一印象，</span>
        <span>从材质开始</span>
      </h1>
      <div className="home-story-opening-foot">
        <p>比较色彩、材料与工艺，放进 3D 情绪板，直接渲染出图。</p>
        <div className="home-story-actions">
          <Link className="home-cta is-solid" to={signedIn ? "/workbench" : "/moodboard"} aria-busy={loadingSession}>
            <span>{signedIn ? "继续创作" : "开始创作"}</span>
            <i aria-hidden="true"><ArrowRight size={18} strokeWidth={1.8} /></i>
          </Link>
          <Link className="home-cta is-text" to="/library?kind=material">浏览材质库</Link>
        </div>
      </div>
    </div>
  );
}
